export default __webpack_public_path__ + "static/media/CustomerRealCase1-moblie.80c1adba.jpg";